import {
  IData, IList, INotification, IResponse,
} from '@/types/interfaces';
/* eslint-disable import/no-cycle */
import ApiService from '@/services/ApiService';
import { ITEMS_ON_PAGE } from '@/types/consts';
import { SORT_TYPE } from '@/types/enums';

export default class AlertsService {
  public static fetchAlerts(page: number, searchTerm: string): Promise<IResponse<IData<IList<INotification>>>> {
    const payload = {
      paging: { page, itemsOnPage: ITEMS_ON_PAGE },
      sort: [{ field: 'UPDATED', order: SORT_TYPE.DESC }],
      searchTerm,
    };
    return ApiService.postAndReturnData('/user/notifications', payload);
  }
}
